import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wiki-components',
  templateUrl: './wiki-components.component.html',
  styleUrls: ['./wiki-components.component.scss']
})
export class WikiComponentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
